import React from 'react';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
interface CTAButtonProps {
  className?: string;
}
export function CTAButton({
  className = ''
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center w-full max-w-xl mx-auto ${className}`} data-id="element-30">
      <a href="https://checkout.librofy.store/checkouts/cn/hWNASLMFcoZLI7CuL7ZBbarq/es-ar?_r=AQABIpbZY25iZdIr--IJ59tvhh0FWdD8Tl99Y7M_xLV34A0&cart_link_id=2ubHl0TS&preview_theme_id=160306823389" target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-gradient-to-b from-gold-400 to-gold-600 text-background font-bold text-xl md:text-2xl py-5 px-8 rounded-xl shadow-[0_0_30px_rgba(212,168,83,0.3)] hover:shadow-[0_0_40px_rgba(212,168,83,0.5)] hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 relative overflow-hidden" data-id="element-31">
        <div className="absolute top-0 right-0 bg-black/20 text-black text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-32">
          $19.990
        </div>
        <span className="block mb-1 mt-1" data-id="element-33">
          Sí, quiero el Pack Completo de 6 Tomos
        </span>
        <span className="block text-sm md:text-base font-medium opacity-90" data-id="element-34">
          y empezar a dominar mi dinero hoy mismo
        </span>
      </a>

      <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 mt-4 text-xs md:text-sm text-gray-300 font-medium" data-id="element-35">
        <div className="flex items-center gap-1.5" data-id="element-36">
          <Lock className="w-4 h-4 text-gold-500" data-id="element-37" />
          <span data-id="element-38">Compra 100% segura</span>
        </div>
        <span className="hidden md:inline text-gray-500" data-id="element-39">•</span>
        <div className="flex items-center gap-1.5" data-id="element-40">
          <Zap className="w-4 h-4 text-gold-500" data-id="element-41" />
          <span data-id="element-42">Acceso inmediato</span>
        </div>
        <span className="hidden md:inline text-gray-500" data-id="element-43">•</span>
        <div className="flex items-center gap-1.5" data-id="element-44">
          <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-45" />
          <span data-id="element-46">Garantía de 30 días</span>
        </div>
      </div>
    </div>;
}